<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">Data View Preferences
    </legend>
  </div>
  <form id="userPreferencesHeadForm" role="form" [formGroup]="userPreferencesHeadForm">
    <div class="grid-row grid-gap-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="screen_name" class="usa-label">Screen Name<abbr title="required"
                                                  class="usa-hint usa-hint--required">*</abbr></label>
        <select id="screen_name" class="usa-select" formControlName="screenName"
                (change)="screenNameChange($event)" required>
          <option value='null' selected disabled>Choose...</option>
          <option *ngFor="let option of listOptions" [value]="option.value">
            {{option.name}}
          </option>
          <!-- <option value="HHGIffMaster">HHG IFF Summary Preferences</option> -->
        </select>
      </div>
    </div>
  </form>
  <div [hidden]="!showBody">
    <app-user-pref-body [screenName] = "this.screenName"></app-user-pref-body>
  </div>
</div>
